import { html as a, when as t } from "@microsoft/fast-element";
const i = (o) => {
  const c = a.partial(o.prefix);
  return a`
    <div class="control" part="control">
      ${t(
    (e) => e.selectable,
    a`
          <${c}-checkbox
            @change="${(e) => e.handleCheckboxChange()}"
            @click="${(e, r) => r.event.stopPropagation()}"
            ?checked="${(e) => e.checked}"
            class="checkbox"
          ></${c}-checkbox>
        `
  )}

      <div class="container">
        <div class="header">
          <div class="header-title">
            <slot name="header"></slot>
          </div>
          <${c}-icon class="header-arrow" name="arrow-up-right"></${c}-icon>
        </div>

        <div class="body">
          <slot></slot>
        </div>
      </div>
    </div>
  `;
};
export {
  i as cardTemplate
};
